const Diagrams = () => {
  return <div>Future Diagrams</div>;
};

export { Diagrams };
